// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageTooltip_container__3XPY2","imageTooltip":"ImageTooltip_imageTooltip__h0PB-","itemContainer":"ImageTooltip_itemContainer__31sBs"};